import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="py-5">
          {/* About Us */}
          <Col lg={3} md={6} className="mb-4">
            <h5>About Us</h5>
            <p>
              Aroghya Radham was founded with a singular mission to provide compassionate, professional and
              reliable home nursing services to the residents of Guntur and sorrounding areas. Our journey began
              with a deep understanding of the challenges that individuals and families face when
              managing health conditions at home.
            </p>
          </Col>

          {/* Quick Links */}
          <Col lg={3} md={6} className="mb-4">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/core-services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </Col>

          {/* Our Services */}
          <Col lg={3} md={6} className="mb-4">
            <h5>Our Services</h5>
            <ul className="list-unstyled">
              <li><Link to="/core-services#home-based-care">Home Based Care</Link></li>
              <li><Link to="/core-services#elderly-care">Elderly Care</Link></li>
              <li><Link to="/core-services#palliative-care-services">Palliative Care</Link></li>
              <li><Link to="/core-services#doctor-home-visit-services">Doctor Home Visit</Link></li>
              <li><Link to="/other-services#physiotherapy">Physiotherapy</Link></li>
              <li><Link to="/other-services#wound-care">Wound Care</Link></li>
            </ul>
          </Col>

          {/* Contact Us */}
          <Col lg={3} md={6} className="mb-4">
            <h5>Contact Us</h5>
            <ul className="list-unstyled contact-list">
              <li>
                <FaMapMarkerAlt className="me-2" />
                <span>No.41, K.R.Road Chebrole, Guntur, Andhra Pradesh - 522212, India</span>
              </li>
              <li>
                <FaPhone className="me-2" />
                <a href="tel:+919361207761">+91 93612 07761</a>
              </li>
              <li>
                <FaPhone className="me-2" />
                <a href="tel:+919281474570">+91 9281474570</a>
              </li>
              <li>
                <FaEnvelope className="me-2" />
                <a href="mailto:info@aroghyaradham.com">info@aroghyaradham.com</a>
              </li>
            </ul>
            <div className="social-links mt-3">
              <a href="#facebook"><FaFacebook /></a>
              <a href="#youtube"><FaYoutube /></a>
              <a href="#instagram"><FaInstagram /></a>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <Row className="border-top pt-3">
          <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
            <p className="mb-0">© 2026 Aroghya Radham. All Rights Reserved.</p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            {/* <p className="mb-0">Site Powered By: Pivot Sofware & Consultancy LLP,.</p> */}
          </Col>
        </Row>
      <Row>
        <Col className="text-center mt-2">
          <p className="mb-0">Made with <span style={{color: 'red'}}>&hearts;</span> by PIVOT SOFT</p>
          <div style={{marginBottom: '1.5rem'}}></div>
        </Col>
      </Row>
      </Container>
    </footer>
  );
};

export default Footer;
